'use client';

import { FC } from 'react';
import useGetReadyPromotions from '../hooks/useGetReadyPromotions';
import { __ } from '../../../translations';
import CarouselWrapper from './presentation/CarouselWrapper';
import { usePromotionUtils } from '../hooks/useMainPromotions';

interface LongVerticalProps {
    name: string;
    carousel: any;
}

/**
 * LongVertical Component
 * A reusable component for displaying vertical content layouts
 */
export const LongVertical: FC<LongVerticalProps> = ({ name, carousel }) => {
    const promoUtils = usePromotionUtils({ name });
    const { promotions, isLoading, isError, isSuccess, isFetching } = useGetReadyPromotions(carousel);
    const shouldShowLoader = (isLoading || isFetching) && !(isError || isSuccess);

    // Early return: Handle API error
    if (isError) {
        return null;
    }

    // Early return: Handle no promotions data
    if (isSuccess && (!promotions || promotions.length === 0)) {
        return null;
    }

    return (
        <CarouselWrapper
            carousel={carousel}
            isLoading={shouldShowLoader}
            promotions={promotions}
            promoHelpers={promoUtils}
        />
    );
};

export default LongVertical;
